
  import {Component, Vue} from 'vue-property-decorator';
  import Header from "@/components/Header.vue";
  import LandingSection from "@/components/LandingSection.vue";
  import PlatformChoice from "@/components/PlatformChoice.vue";
  import DownloadWin33 from "@/components/DownloadWin33.vue";
  import DownloadMac33 from "@/components/DownloadMac33.vue";
  import DownloadLin33 from "@/components/DownloadLin33.vue";
  import DownloadZip33 from "@/components/DownloadZip33.vue";
  import License from "@/components/License.vue";
  import {gaSendPageview} from "@/components/Analytics";
  import Cookies from "js-cookie";

  @Component({
    components: {DownloadZip33, DownloadLin33, DownloadMac33, DownloadWin33, LandingSection, Header, PlatformChoice, License}
  })
  export default class Download33 extends Vue {
    private isPaidDownload = false;
    private versionShort = "3.3";
    private version = "3.3.3316";
    private releaseDate = "30 Jan, 2025";
    private winMsiSize = "132 Mb";
    private winMsiMd5 = "65d8eb2653878309c4b809c1559268a9";
    private winMsiVirusTotal = "3a7f6804686937140dce07a7abc73e27f8b3d58a5dd650f51d8865f2580807d9";
    private winExeSize = "130 Mb";
    private winExeMd5 = "9505f15f583b155c52c6f50aa225e263";
    private winExeVirusTotal = "fca6588d97615ce1f293d554fcebdc6c3f40d46ebd4eb6c1b117ca5f31f6b3e1";
    private macSiliconSize = "132 Mb";
    private macIntelSize = "136 Mb";
    private linSize = "93 Mb";
    private zipSize = "52 Mb";

    constructor() {
      super();
      if (Cookies.get("download-visited") === undefined && !this.hasUtmSource()) {
        window.location.replace("/download");
      }
      this.isPaidDownload = window.location.pathname.endsWith("paid");
    }

    private hasUtmSource(): boolean {
      const searchParams = new URLSearchParams(window.location.search);
      return searchParams.has("utm_source");
    }
    private cdnUrl(path: string): string {
      return path;
    }

    public mounted() {
      gaSendPageview();
    }
  }
